import { ILocationEditModelResponse } from '@ready/dashboardv2api.contracts';
export const cachedLocation = {} as ILocationEditModelResponse;
